import React from "react";
import Modal from "../../../../../../../../components/ui/modal/Modal";
import classes from "./ProductAddedModal.module.css";
import JustForYou from "../../../../../../../landing/components/justForYou/JustForYou";
import LoadingSpinner from "../../../../../../../../components/ui/loadingSpinner/LoadingSpinner";
const ProductAddedModal = (props) => {
  return (
    <div className={classes.loading}>
      <LoadingSpinner />
    </div>
  );
};

export default ProductAddedModal;
